<template>
    <div class="homeCardIndex" data-step="4" data-intro="点击查看考勤异常与已休假期统计~">
        <!-- <div @click="urlConfig('dk')" class="dk">{{dk}}<p>考勤异常</p></div> -->
        <!-- <div @click="urlConfig('qj')" class="qj">{{qj}}<p>请假天数</p></div> -->

        <div @click="urlConfig('dk')" class="mode">
            <div class="dk">{{dk}}</div>
            <div class="item">考勤异常</div>
        </div>

        <div @click="urlConfig('qj')" class="mode">
            <div class="qj">{{qj}}</div>
            <div class="item">请假天数</div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                qj:0,
                dk:0
            }
        },
        mounted:function(){//加载事件
            this.initData();//加载时触发数据填充
        },
        methods:{
            //下面是函数
            initData(){
                // this.$http.post(`${window.context.portal}/bpm/haiyaapi/getKqmx`).then((resp) => {
                //     this.qj = resp.data.qj;
                //     this.dk = resp.data.dk;
                // });
            },
            urlConfig(item){
                if(item=='dk'){
                    window.open('/fvue/statement/querySql/queryView/kqyc/kqycmx/true');
                }else{
                    window.open('/fvue/statement/querySql/queryView/grqjmx/grqj/true');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .mode{
    padding-top: 8px;
    display: inline-block; 
    vertical-align: middle; 
    width:50%;
    text-align: center;
}

/deep/ .item{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #52535E;
    }

/deep/ .dk{
    font-size: 24px;
    font-family: JDZhengHT-Regular, JDZhengHT;
    font-weight: 400;
    color: #E70D0D;
    padding-bottom: 8px;
}
/deep/ .qj{
    font-size: 24px;
    font-family: JDZhengHT-Regular, JDZhengHT;
    font-weight: 400;
    color: #292B44;
    padding-bottom: 8px;
}

</style>
